import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const userService = {
  async getUsers() {
    const response = await axios.get(`${API_URL}/api/auth/admin/usuarios`, { withCredentials: true });
    return response.data;
  },
  async createUser(userData) {
    const response = await axios.post(`${API_URL}/api/auth/admin/usuarios`, userData, { withCredentials: true });
    return response.data;
  },
  async updateUser(id, userData) {
    const response = await axios.put(`${API_URL}/api/auth/admin/usuarios/${id}`, userData, { withCredentials: true });
    return response.data;
  },
  async getUserToken() {
    const response = await axios.get(`${API_URL}/api/auth/get-user-token`, { withCredentials: true });
    return response.data;
  }
};

export default userService; 